import ApiHelper from "./ApiHelper";

class CandidateServices {

    static async getCandidateList(str) {
        return ApiHelper.getAuthenticated(`professional?${str}`);
    }

    static async revokeAccess(id) {
        return ApiHelper.getAuthenticated(`professional/access/${id}`);
    }

    static async getCandidateById(id) {
        return ApiHelper.getAuthenticated(`professional/info/${id}`);
    }

    static async UpdateCandidateStatus(body) {
        return ApiHelper.patchAuthenticated(`applications/${body._id}`, body);
    }

    static async GetApplications(body) {
        return ApiHelper.getAuthenticated(`applications/job/${body.jobID}`);
    }

    static async CreateComment(body) {
        return ApiHelper.postAuthenticated("comments", body);
    }

    static async GetComments(body) {
        return ApiHelper.getAuthenticated(`comments/${body.jobID}`);
    }

    static async CreateReply(body) {
        return ApiHelper.postAuthenticated(`comments/${body.commentId}/reply`, body);
    }

    static async UpdateApplicantsFeedback(body) {
        return ApiHelper.putAuthenticated(`applications/${body._id}/feedback`, body);
    }

    static async DownloadApplicantsFeedback(body) {
        return ApiHelper.postAuthenticated('download-applicants-feedback', body);
    }

}
export default CandidateServices;

